export const AddMoveableAssetModalStyle = (theme) => ({
  formContainer: {
    maxHeight: '60vh',
    overflowY: 'auto',
    paddingRight: '10px',
    '& .ant-form-item-label': {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      lineHeight: '1.4',
    },
  },
  actionButtons: {
    textAlign: 'right',
    marginTop: '20px',
  },
  cancelButton: {
    marginRight: '10px',
  },
  date: {
    width: '100%',
  },
});
